import { render, staticRenderFns } from "./HtmlColumn.vue?vue&type=template&id=09c1c0c3&"
import script from "./HtmlColumn.vue?vue&type=script&lang=js&"
export * from "./HtmlColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports